<template>
<div>
<component
  :is='style'
  v-if="headings_url"
>
@font-face {
  font-family: {{ CUSTOM_HEADINGS_NAME }};
  src: url('{{ headings_url }}');
}
</component>

<component
  :is='style'
  v-if="headings_url || headings_family"
>
  h1, h2, h3, h4, h5, h6,
  .heading-one,
  .heading-two,
  .heading-three,
  .heading-four,
  .heading-five,
  .heading-six,
  .h-one,
  .h-one-light,
  .h-two,
  .h-two-light,
  .h-three,
  .h-three-light,
  .h-four,
  .h-four-light,
  .h-four-branded,
  .h-five,
  .h-five-light {
    font-family: {{ CUSTOM_HEADINGS_NAME }} {{ headings_family ? ', ' + headings_family : '' }} !important;
    {{ headings_url ? 'font-weight: 400 !important;' : '' }}
  }
</component>

<component
  :is='style'
  v-if="font_url"
>
@font-face {
  font-family: {{ CUSTOM_FONT_NAME }};
  src: url('{{ font_url }}');
}
</component>

<component
  :is='style'
  v-if="font_url || font_family"
>
  .body-one,
  .body-one-light,
  .body-two,
  .body-two-light,
  .body-three,
  .body-three-light,
  .body-four,
  .body-four-light,
  .body-four-branded,
  .body-five,
  .body-five-light,
  .body-six,
  .body-six-light,

  .copy-one,
  .copy-two,
  .copy-three,
  .copy-four,

  .link-one,
  .link-one-light,
  .link-one-grey,
  .link-one-gray,
  .link-one-branded,
  .link-two,
  .link-two-light,
  .link-two-grey,
  .link-two-gray,
  .link-two-branded,
  .link-three,
  .link-three-light,
  .link-three-grey,
  .link-three-gray,
  .link-three-branded,

  .button-one,
  .button-one-light,
  .button-one-branded,
  .button-two,
  .button-two-light,
  .button-three,
  .button-three-light,
  .button-three-grey,
  .button-three-blue,
  .button-three-branded,
  .action-one-branded,

  .slide-basic-content_body,

  .main-nav-link,

  form input,
  form label,
  form select,
  form textarea,
  form button,

  .lesson-container .slide-article_body a,
  .lesson-container .slide-article_body ol li,
  .lesson-container .slide-article_body p,
  .lesson-container .slide-article_body ul li,

  body {
    font-family: {{ CUSTOM_FONT_NAME }} {{ font_family ? ', ' + font_family : '' }} !important;
  }
</component>

<component
  :is='style'
  v-if="brand_color"
>
/* Custom background */
.self-assessment_question_options--text .self-assessment_question_options_option:hover,
.self-assessment_question_options--text .self-assessment_question_options_option.selected,
body:not(.is-ios-device) .self-assessment_question_options--text .self-assessment_question_options_option:hover .self-assessment_question_options_option-circle:after,
.self-assessment_question_options--text .self-assessment_question_options_option.selected .self-assessment_question_options_option-circle:after,

.self-assessment_question_options--scale .self-assessment_question_options_option:hover .self-assessment_question_options_option-circle,
.self-assessment_question_options--scale .self-assessment_question_options_option.selected .self-assessment_question_options_option-circle,

.self-assessment_question_options--round-button .self-assessment_question_options_option:hover,

.self-assessment_close-confirm,
.self-assessment_encouragement,

.intention-setter_question_options_option:hover,
.intention-setter_question_options_option.selected,
body:not(.is-ios-device) .intention-setter_question_options_option:hover .intention-setter_question_options_option-circle:after,
.intention-setter_question_options_option.selected .intention-setter_question_options_option-circle:after,
.intention-setter_close-confirm,

.switch_input:checked + .switch_label:before,

.card_current-progress,

.mobile-outline_link.mobile-outline_link--current,

.slide-nav_progress-bar,
.action-one-branded,

.button-one-branded,
.button-three-branded:hover
  { background-color: {{ brand_color }} !important; }

.intention-setter_results-image {
  background-image: radial-gradient({{ brand_color }} 70%, transparent calc(70% + 1px));
}

.action-one-branded:hover {
  background-color: transparent !important;
}

/* Custom text color */
.h-four-branded,
.body-four-branded,
.button-three-branded,

.link-one-branded,
.link-two-branded,
.link-three-branded,

.self-assessment-results_outcome-cta.copy-two,

.page-loader .loader,
.lesson-slides_loader-inner,
.course-app_loader-inner,
.lesson-app_loader-inner
  { color: {{ brand_color }} !important; }

/* Custom borders */
.action-one-branded,
.button-three-branded,

.intention-setter_navigation button:hover,
.self-assessment_navigation_next:hover,
.self-assessment_navigation_back:hover
  { border-color: {{ brand_color }} !important; }
</component>
</div>
</template>

<script>
export default {
  props: [
    'brand_color',
    'font_family',
    'font_url',
    'headings_family',
    'headings_url'
  ],

  data() {
    return {
      CUSTOM_FONT_NAME: 'TBK_URLCustomFont',
      CUSTOM_HEADINGS_NAME: 'TBK_URLCustomHeadingsFont'
    }
  }

}
</script>
